import React from "react";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import Typography from "@material-ui/core/Typography";

import { ERROR_MESSAGE } from "../../constants/testIds";
import { withStyles, Styles } from "./styles";

export const BaseErrorMessage: React.FC<Styles> = ({ classes }) => {
  const formatMessage = useFormatMessage();
  return (
    <div className={classes.container} data-testid={ERROR_MESSAGE}>
      <Typography variant="body2" color="inherit">
        {formatMessage("reviews.reviewForm.submitError")}
      </Typography>
    </div>
  );
};

export const ErrorMessage = withStyles(BaseErrorMessage);
